import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ACCENT = '#0f766e';
const ACCENT_SOFT = 'rgba(15, 118, 110, 0.10)';

const tabs = [
    { label: 'Search', icon: 'bx bx-search', path: '/institution/ehr' },
    { label: 'Browse All', icon: 'bx bx-folder-open', path: '/institution/ehr/list' },
    { label: 'Create', icon: 'bx bx-plus-medical', path: '/institution/ehr/new' },
    { label: 'Share', icon: 'bx bx-export', path: '/institution/ehr/share' },
    { label: 'Shared With Us', icon: 'bx bx-cloud-download', path: '/institution/ehr/shared' },
    { label: 'Activity', icon: 'bx bx-history', path: '/institution/ehr/activity' },
];

const EHRNav: React.FC = () => {
    const location = useLocation();

    return (
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 24, padding: '4px', background: 'rgba(15,23,42,0.025)', borderRadius: 12 }}>
            {tabs.map(t => {
                const isActive = location.pathname === t.path;
                return (
                    <Link key={t.path} to={t.path} style={{
                        display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 10,
                        textDecoration: 'none', fontWeight: isActive ? 700 : 500, fontSize: '0.8rem',
                        transition: 'all 0.15s',
                        background: isActive ? '#fff' : 'transparent',
                        color: isActive ? ACCENT : 'var(--uzima-shell-text-muted, #64748b)',
                        boxShadow: isActive ? '0 1px 4px rgba(0,0,0,0.06)' : 'none',
                    }}>
                        <i className={t.icon} style={{ fontSize: '1rem' }}></i>
                        {t.label}
                    </Link>
                );
            })}
        </div>
    );
};

export default EHRNav;
